export const eventKeys = {
    "top": ["ArrowUp", "w"],
    "bottom": ["ArrowDown", "s"],
    "left": ["ArrowLeft", "a"],
    "right": ["ArrowRight", "d"]
}